import { render } from "./ControlPanelSidebar.vue?vue&type=template&id=0815cbc0&scoped=true"
import script from "./ControlPanelSidebar.vue?vue&type=script&lang=js"
export * from "./ControlPanelSidebar.vue?vue&type=script&lang=js"

import "./ControlPanelSidebar.vue?vue&type=style&index=0&id=0815cbc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0815cbc0"]])

export default __exports__